import {
  PassengerIcon,
  SuitcaseIcon,
  ChargerIcon,
  WifiIcon,
  TvIcon,
  DvdIcon,
} from "../../../../components/icons";
import { Trans, useTranslation } from "react-i18next";
import { cn } from "../../../../utils/classnames";
import { createTypographyHelper } from "../../../../utils/typography";
export const CarFeature = ({ passengers, suitcases }) => {
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);
  return (
    <>
      {/* Passenger Capacity */}
      <div className="tw:flex tw:flex-col tw:gap-y-3 tw:justify-center tw:items-center tw:flex-1 tw:h-[128px] tw:px-7 tw:border-r tw:border-[#F1F1F1] tw:col-span-6 tw:xl:col-span-2">
        <PassengerIcon />
        <div
          className={cn(
            "tw:text-center tw:font-hanken-grotesk tw:text-[#282828]",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          <Trans
            i18nKey="FleetTypePage.Passengers"
            values={{ count: passengers }}
            components={{
              strong: <strong></strong>,
            }}
          />
        </div>
      </div>

      {/* Suitcase Capacity */}
      <div className="tw:flex tw:flex-col tw:gap-y-3 tw:justify-center tw:items-center tw:flex-1 tw:h-[128px] tw:px-7 tw:border-r tw:border-[#F1F1F1] tw:col-span-6 tw:xl:col-span-2">
        <SuitcaseIcon />
        <div
          className={cn(
            "tw:text-center tw:font-hanken-grotesk tw:text-[#282828]",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          <Trans
            i18nKey="FleetTypePage.Suitcases"
            values={{ count: suitcases }}
            components={{
              strong: <strong></strong>,
            }}
          />
          <div className="tw:text-[#8D8D8D] tw:text-[12px] tw:!font-[400] tw:leading-4">
            {t("FleetTypePage.suitcaseNote")}
          </div>
        </div>
      </div>

      {/* Mobile Device Charger */}
      <div className="tw:flex tw:flex-col tw:gap-y-3 tw:justify-center tw:items-center tw:flex-1 tw:h-[128px] tw:md:px-7 tw:border-r tw:border-[#F1F1F1] tw:col-span-3 tw:xl:col-span-2 tw:border-t tw:border-t-[#F1F1F1] tw:xl:border-t-0">
        <ChargerIcon
          aria-label="Mobile Device Charger"
          role="img"
          style={{ width: "16px", height: "16px" }}
        />
        <div
          className={cn(
            "tw:text-center tw:font-hanken-grotesk tw:text-[#282828]",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          {t("MobileDeviceCharger")}
        </div>
      </div>

      {/* In-car WiFi */}
      <div className="tw:flex tw:flex-col tw:gap-y-3 tw:justify-center tw:items-center tw:flex-1 tw:h-[128px] tw:md:px-7 tw:border-r tw:border-[#F1F1F1] tw:col-span-3 tw:xl:col-span-2 tw:border-t tw:border-t-[#F1F1F1] tw:xl:border-t-0">
        <WifiIcon
          aria-label="In-car WiFi"
          role="img"
          style={{ width: "16px", height: "16px" }}
        />
        <div
          className={cn(
            "tw:text-center tw:font-hanken-grotesk tw:text-[#282828]",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          {t("InCarWiFi")}
        </div>
      </div>

      {/* Television */}
      <div className="tw:flex tw:flex-col tw:gap-y-3 tw:justify-center tw:items-center tw:flex-1 tw:h-[128px] tw:md:px-7 tw:border-r tw:border-[#F1F1F1] tw:col-span-3 tw:xl:col-span-2 tw:border-t tw:border-t-[#F1F1F1] tw:xl:border-t-0">
        <TvIcon
          aria-label="Television"
          role="img"
          style={{ width: "16px", height: "16px" }}
        />
        <div
          className={cn(
            "tw:text-center tw:font-hanken-grotesk tw:text-[#282828]",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          {t("Television")}
        </div>
      </div>

      {/* DVD Player */}
      <div className="tw:flex tw:flex-col tw:gap-y-3 tw:justify-center tw:items-center tw:flex-1 tw:h-[128px] tw:md:px-7 tw:col-span-3 tw:xl:col-span-2 tw:border-t tw:border-t-[#F1F1F1] tw:xl:border-t-0">
        <DvdIcon
          aria-label="DVD Player"
          role="img"
          style={{ width: "16px", height: "16px" }}
        />
        <div
          className={cn(
            "tw:text-center tw:font-hanken-grotesk tw:text-[#282828]",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          {t("DVDPlayer")}
        </div>
      </div>
    </>
  );
};
